import { getRenderedText } from "@angular/core/src/render3";
import { parseHttpResponse } from "selenium-webdriver/http";

export interface CollapseState {
  chartElementID: string[];
  isCollapsed: boolean[];
}

export interface Resident {
  residentName: string;
  residentAge: number;
  residentGender: string;
  pcPhase: string;
  expertType: string;
  deathDate: Date;
  lastAcpReviewDate: Date;
  lastFamilyConferenceDate: Date;
  lastPCPlanReviewDate: Date;
  lastSdmReviewDate: Date;
  lastSpictDate: Date;
  hasBereavementSupport: boolean;
  hasExpertInput: boolean;
  hasGriefSupport: boolean;
  isOnEolPathway: boolean;
  hospitalisationStartDate: Date;
  hospitalisationEndDate: Date;
  hospitalisationReasonCode: string;
}

export enum ResidentSortKey {
  Age,
  Gender,
  Name,
  Phase,
}

export interface ChartElementDescriptor {
  legendLabel: string;
  proportion: number;
}

export enum EventType {
  Death,
  Hospitalised,
  LastAcpReview,
  LastFamilyConference,
  LastPCPlanReview,
  LastSdmReview,
  LastSpict
}

// Important: due to input dependencies, items within MetricType must be single words only!
export enum MetricType {
  Expert,      // expert type (e.g., IPCT, NP, SPCS)
  Phase        // PC Phase (e.g., ID, EOL, NE)
}
  
export enum FlagType {
  Bereavement,  // family bereavement supported
  Expert,       // has expert input
  Eol,          // on EOL pathway
  Grief         // resident grief supported
}

export enum ShortMonthName {
  Jan = 0,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec
}
  